import React from "react";
import { PageLoading } from "../../components";
import { usePrimaryOrganizationId, useSelf } from "../../hooks";
import { InviteUsersAquilo, WelcomeOverlay } from "../../components/get-compliant/WelcomeOverlay";
import { useHistory } from "react-router";
import { useSelfOrganizationUser } from "../../hooks/useOrganization";
import { Routes } from "../../root/routes";

export const GetCompliantDashboardPage: React.FC = () => {
  const organizationId = usePrimaryOrganizationId()!!;
  const [self] = useSelf();
  const selfOrgUser = useSelfOrganizationUser();
  const history = useHistory();

  if (!self || !selfOrgUser) {
    return <PageLoading />;
  }

  return (
    <WelcomeOverlay
      organizationId={organizationId}
      skipInvitations={selfOrgUser?.role !== "ADMIN" || self?.viewedWelcomeScreen}
      onClose={() => {
        if (selfOrgUser.role === "HR") {
          history.push(Routes.hrCenter.root);
        } else {
          history.push(Routes.getCompliant.privacyCenter.domainSetup);
        }
      }}
      alreadyViewedWelcomeScreen={self?.viewedWelcomeScreen}
    />
  );
};

export function GetCompliantInviteUsersPage() {
  const history = useHistory();
  const organizationId = usePrimaryOrganizationId()!!;

  if (!organizationId) {
    return <PageLoading />;
  }

  return (
    <InviteUsersAquilo
      organizationId={organizationId}
      onDone={() => {
        history.push(Routes.getCompliant.privacyCenter.domainSetup);
      }}
    />
  );
}
